function setCookie(t, e, i = {}) {
  (i = { path: "/" }).expires instanceof Date &&
    (i.expires = i.expires.toUTCString());
  let o = encodeURIComponent(t) + "=" + encodeURIComponent(e);
  for (let a in i) {
    o += "; " + a;
    let n = i[a];
    !0 !== n && (o += "=" + n);
  }
  document.cookie = o;
}
function getCookie(t) {
  let e = document.cookie.match(
    RegExp(
      "(?:^|; )" +
      t.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
      "=([^;]*)"
    )
  );
  return e ? decodeURIComponent(e[1]) : void 0;
}
function deleteCookie(t) {
  setCookie(t, "", { "max-age": -1 });
}
$(document).ready(function () {
  if (void 0 !== __st && void 0 !== __st.cid) {
    let t = getCookie("register"),
      e = getCookie("login");
    "1" == t
      ? (deleteCookie("register"),
        (window.dataLayer = window.dataLayer || []),
        dataLayer.push({ event: "sign_up", user_id: __st.cid }))
      : "1" == e &&
      (deleteCookie("login"),
        (window.dataLayer = window.dataLayer || []),
        dataLayer.push({ event: "login", user_id: __st.cid })),
      setCookie("user_id", __st.cid, { secure: !0, "max-age": 3600 }),
      localStorage.setItem("user_id", __st.cid);
  }
  var i = detect.parse(navigator.userAgent);
  $("html").addClass(i.browser.family),
    console.log(i.browser.family),
    $(window).width() > 767 &&
    $(".banner-video.banner-img").append(
      '<video playsinline="true" disablePictureInPicture autoplay="true" muted="muted" id="videoTeaser" loop="true"><source id="videoTeaserSource" src="https://cdn.shopify.com/s/files/1/2373/2631/files/girl_3.mp4?v=1603183149" type="video/mp4"></video>'
    ),
    $(window).resize(function () {
      $(window).width() > 767 &&
        !$(".banner-video.banner-img").find($("#videoTeaser")) &&
        $(".banner-video.banner-img").append(
          '<video playsinline="true" disablePictureInPicture autoplay="true" muted="muted" id="videoTeaser" loop="true"><source id="videoTeaserSource" src="https://cdn.shopify.com/s/files/1/2373/2631/files/girl_3.mp4?v=1603183149" type="video/mp4"></video>'
        );
    });
  var o = document.getElementById("videoTeaser");
  o &&
    (o.oncanplaythrough = function () {
      o.play();
    }),
    767 >= $(window).width() &&
    $(".section-heading__more").each(function () {
      $(this).appendTo($(this).closest(".container"));
    }),
    1200 >= $(window).width() &&
    ($(".article-side .article-tags").insertAfter(".article-share")),
    $(document).on("click", "#_add_to_bag-notification-close_btn", function () {
      $("#_add_to_bag-notification").hide();
    }),
    $(document).on("click", ".grid__product-card", function () {

      const card = $(this);
      if ($(event.target).closest(".variant-selector-container").length > 0) {
        event.preventDefault();

        return;
      }
      const parentContainer = card.closest("[data-index]");
      let index = parentContainer.data("index");
      const form = card.find(".product-card-form");
      const itemName = form.data("title");
      const productId = parseInt(form.data("product_id"));
      const variantId = parseInt(form.data("variant_id"));
      const variantTitle = form.data("variant_title");
      const price = parseFloat(form.data("price"));
      const collection = form.data("collection_1");
      const img = form.data("img");

      if (index === undefined) {
        const parentBlock = card.closest("[data-block-name]");
        const cardsInContainer = parentBlock.find(".grid__product-card");
        index = cardsInContainer.index(card) + 1;
      }

      saveProductData(card, index);
      const productData = JSON.parse(localStorage.getItem("productData")) || [];
      const productIdStr = productId.toString();
      const productVariantId = variantId.toString();

      let productInfo = productData.find(
        (item) => item.id.toString() === productIdStr
      );

      if (!productInfo) {
        productInfo = productData.find(
          (item) => item.id.toString() === productVariantId
        );
      }

      const blockName = productInfo ? productInfo.blockName : "Direct";
      const position = productInfo ? productInfo.position : 1;

      const categoryData = {
        "Music Streaming": {
          "Spotify Promotion": "Music Streaming",
          "Apple Music Promotion": "Music Streaming",
          "Tidal Promotion": "Music Streaming",
          "Audiomack Promotion": "Music Streaming",
          "Deezer Promotion": "Music Streaming",
          "Playlist Placement": "Music Streaming",
          "Hip-Hop Promotion": "Music Streaming",
        },
        "Social Promotion": {
          "Instagram Promotion": "Social Promotion",
          "TikTok Promotion": "Social Promotion",
          "Facebook Promotion": "Social Promotion",
          "Resident Advisor Promotion": "Social Promotion",
          "Music Blogs Submission": "Social Promotion",
        },
        "Music Promotion": {
          "Youtube Promotion": "Music Promotion",
          "SoundCloud Promotion": "Music Promotion",
          "iTunes Top 100 Promotion": "Music Promotion",
          "Beatport Promotion": "Music Promotion",
          "Music Promotion Packages": "Music Promotion",
          "Shazam Promotion": "Music Promotion",
          "Bandcamp Promotion": "Music Promotion",
          "Mixcloud Promotion": "Music Promotion",
          "Music Promotion Guides": "Music Promotion",
        },
      };

      let itemCategory2 = "";
      let itemListName = blockName;

      for (const [parentCategory, subCategories] of Object.entries(
        categoryData
      )) {
        if (subCategories[collection]) {
          itemCategory2 = parentCategory;
        }
        if (subCategories[blockName]) {
          itemListName = `${parentCategory} || ${blockName}`;
        }
      }

      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "select_item",
        ecommerce: {
          items: [
            {
              item_name: itemName.trim(),
              item_id: `shopify_US_${productId}_${variantId}`,
              price: price,
              item_category: itemCategory2,
              item_category2: collection,
              item_variant: variantTitle,
              item_list_name: itemListName,
              index: position,
            },
          ],
        },
      });
    });
  $(document).ready(function () {
    $("#contact_form").on("submit", function (e) {
      e.preventDefault();

      var formData = $(this).serialize();

      $.ajax({
        url: "/contact#contact_form",
        type: "POST",
        data: formData,
        success: function (response) {
          e.preventDefault();
          console.log(response);
        },
        error: function (xhr, status, error) {
          e.preventDefault();
          console.log(error);
        },
      });
    });
  });
  function saveProductData(card, index) {
    const productId = card.data("product-id");
    const blockName = card.closest("[data-block-name]").data("block-name");

    let productData = JSON.parse(localStorage.getItem("productData")) || [];

    const productExists = productData.some((item) => item.id === productId);

    if (!productExists) {
      productData.push({
        id: productId,
        blockName: blockName,
        position: index > 0 ? index : 1,
      });
      localStorage.setItem("productData", JSON.stringify(productData));

      console.log("Saved Product Data:", {
        id: productId,
        blockName: blockName,
        position: index,
      });
    } else {
      console.log(`Product with ID ${productId} is already in localStorage.`);
    }
  }
  $(document).on("submit", ".product-card-form", function (t) {
    t.preventDefault();
    const form = $(this);
    const card = form.closest(".grid__product-card");
    const index = $(".grid__product-card").index(card);
    let e = $(this).data("title"),
      i = parseInt($(this).data("product_id")),
      o = parseInt($(this).data("variant_id")),
      a = parseFloat($(this).data("price")),
      variantTitle = $(this).data("variant_title"),
      n = $(this).data("collection_1"),
      r = $(this).data("img");

    var c = $(this),
      s = {
        id: c.find('input[name="id"]').val(),
        quantity: c.find('input[name="quantity"]').val(),
      };

    let d = parseInt($(".header__cart-active").text());
    var l = $(".header__cart-active");
    l.text(d + 1),
      l.hasClass("hide") && l.removeClass("hide"),
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: s,
        dataType: "json",
        success: function (t) {
          $.ajax({
            url: window.Shopify.routes.root + "cart.js",
            method: "GET",
            dataType: "json",
            success: function (t) {
              var e = t;
              var i = e.items.length;
              console.log(i),
                1 === i
                  ? ($("#_discount-text").html(
                    `${window.translations.discountText} <b>${window.translations.discountQuantity}</b>`
                  ),
                    $("#_add_to_bag-notification-discount-label")
                      .removeClass("applied not-showing")
                      .addClass(""))
                  : ($("#_discount-text").html(window.translations.discountApplied),
                    $("#_add_to_bag-notification-discount-label")
                      .removeClass("not-showing")
                      .addClass("applied"));
            },
            error: function (t, e, i) {
              console.error("Error fetching cart contents:", e, i);
            },
          }),
            $("#_add_to_bag-notification-item-title").text(e),
            $("#_add_to_bag-notification-item-price").text("$" + a.toFixed(2)),
            $("#_add_to_bag-notification-item-img").attr("src", r),
            $("#_add_to_bag-notification-item-quantity-count").text("1"),
            $("#_add_to_bag-notification").css("display", "flex");
        },
        error: function (t) {
          console.error("Error adding product to cart:", t);
        },
      });

    const productData = JSON.parse(localStorage.getItem("productData")) || [];
    const productId = i.toString();
    const productVariantId = o.toString();

    let productInfo = productData.find(
      (item) => item.id.toString() === productId
    );

    if (!productInfo) {
      productInfo = productData.find(
        (item) => item.id.toString() === productVariantId
      );
    }

    const blockName = productInfo ? productInfo.blockName : "Direct";
    const position = productInfo ? productInfo.position : 1;

    const categoryData = {
      "Music Streaming": {
        "Spotify Promotion": "Music Streaming",
        "Apple Music Promotion": "Music Streaming",
        "Tidal Promotion": "Music Streaming",
        "Audiomack Promotion": "Music Streaming",
        "Deezer Promotion": "Music Streaming",
        "Playlist Placement": "Music Streaming",
        "Hip-Hop Promotion": "Music Streaming",
      },
      "Social Promotion": {
        "Instagram Promotion": "Social Promotion",
        "TikTok Promotion": "Social Promotion",
        "Facebook Promotion": "Social Promotion",
        "Resident Advisor Promotion": "Social Promotion",
        "Music Blogs Submission": "Social Promotion",
      },
      "Music Promotion": {
        "Youtube Promotion": "Music Promotion",
        "SoundCloud Promotion": "Music Promotion",
        "iTunes Top 100 Promotion": "Music Promotion",
        "Beatport Promotion": "Music Promotion",
        "Music Promotion Packages": "Music Promotion",
        "Shazam Promotion": "Music Promotion",
        "Bandcamp Promotion": "Music Promotion",
        "Mixcloud Promotion": "Music Promotion",
        "Music Promotion Guides": "Music Promotion",
      },
    };

    let itemCategory2 = "";
    let itemListName = blockName;

    for (const [parentCategory, subCategories] of Object.entries(
      categoryData
    )) {
      if (subCategories[n]) {
        itemCategory2 = parentCategory;
      }
      if (subCategories[blockName]) {
        itemListName = `${parentCategory} || ${blockName}`;
      }
    }

    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        items: [
          {
            item_name: e.trim(),
            item_id: "shopify_US_" + i + "_" + o,
            price: a,
            item_category: itemCategory2,
            item_category2: n,
            item_variant: variantTitle,
            item_list_name: itemListName,
            index: position,
            quantity: 1,
          },
        ],
      },
    });

    console.log("Data Layer updated:", {
      event: "add_to_cart",
      item_category: itemCategory2,
      item_category2: n,
      item_list_name: itemListName,
      index: position,
    });
  });
  var a = parseInt($(".header__cart-active").text());
  if (
    ($(".product-single .product-form__cart-submit").click(function () {
      (a += parseInt($(".product-single .js-qty input").val())),
        $(".header__cart-active").text(a);
    }),
      $(".product-form").length)
  ) {
    let n = parseInt($(".product-form .current-price").text().replace(/[$,]/g, "")),
      r = parseInt($(".product-form .old-price").text().replace(/[$,]/g, ""));
    console.log(r),
      $(document).on(
        "click",
        ".product-form .js-qty__adjust--minus, .product-form .js-qty__adjust--plus",
        function () {
          let t = parseInt($(".js-qty__input").val());
          console.log(r),
            n && $(".product-form .current-price").text("$" + t * n),
            r && $(".product-form .old-price").text("$" + t * r);
        }
      ),
      $(document).on(
        "change",
        ".product-form .single-option-selector",
        function () {
          (n = parseInt(
            $(".product-form .current-price").text().replace(/[$,]/g, "")
          )),
            (r = parseInt(
              $(".product-form .old-price").text().replace(/[$,]/g, "")
            )),
            console.log(r);
          let t = parseInt($(".js-qty__input").val());
          n && $(".product-form .current-price").text("$" + t * n),
            r && $(".product-form .old-price").text("$" + t * r);
        }
      );
  }
  $(".cart-layout .js-qty button.js-qty__adjust--minus").click(function () {
    var t = parseInt($(this).siblings("input").val());
    (t -= 1),
      $(this).siblings("input").val(t),
      (a = 0),
      $(".cart-layout .js-qty input").each(function () {
        a += parseInt($(this).val());
      }),
      $(".header__cart-active").text(a);
    let e = parseInt($(this).parent().parent().data("price"));
    $(this)
      .parent()
      .parent()
      .parent()
      .find(".cart__item-total")
      .text(e * t + ".00$");
  }),
    $(".cart-layout .js-qty button.js-qty__adjust--plus").click(function () {
      var t = parseInt($(this).siblings("input").val());
      (t += 1),
        $(this).siblings("input").val(t),
        (a = 0),
        $(".cart-layout .js-qty input").each(function () {
          a += parseInt($(this).val());
        }),
        $(".header__cart-active").text(a);
      let e = parseInt($(this).parent().parent().data("price"));
      $(this)
        .parent()
        .parent()
        .parent()
        .find(".cart__item-total")
        .text(e * t + ".00$");
    });
}),
  $(window).on("scroll", function () {
    $(window).scrollTop() > 300
      ? $(".up").addClass("active")
      : $(".up").removeClass("active");
  }),
  $("body").on("click", ".up", function () {
    $("html, body")
      .stop()
      .animate({ scrollTop: 0 }, 500, "swing", function () { });
  }),
  $("body").on("click", ".blog-tags li.current", function () {
    767 >= $(window).width() &&
      ($(".blog-tags li:not(.current)").slideToggle(),
        $(".blog-tags").toggleClass("active"));
  }),
  $("body").on("click", ".header__nav-toggle", function () {
    $(".header__nav").slideToggle("300"),
      $(".header__nav").toggleClass("active"),
      $(".header__actions").toggleClass("active"),
      $("body, html").toggleClass("ovh"),
      $(this).toggleClass("active"),
      $(".header__top").toggleClass("active"),
      $("header.header").toggleClass("active");
  }),
  $("body").on("change", "#sortCollestions", function () {
    window.location = "?sort_by=" + $(this).val();
  }),
  $("body").on("click", "#RecoverPassword", function () {
    $("#CustomerLoginForm").hide();
    $("#RecoverPasswordForm").show();
  }),
  $("body").on("click", "#HideRecoverPasswordLink", function () {
    $("#CustomerLoginForm").show();
    $("#RecoverPasswordForm").hide();
  }),
  $("body").on("click", ".add-address-toggle", function () {
    $(".add-address").slideToggle(), $(".address-heading .title").toggle();
  }),
  $("body").on("click", ".edit, .order-form-wrap .cancel", function () {
    $(this)
      .closest(".addresses-layout, .addresses-list-m")
      .find(".edit-address, .add-address")
      .slideToggle();
  }),
  $("body").on("click", ".alert__close", function () {
    $(".alert").remove();
  }),
  $("body").on("click", ".product-form__cart-submit", function () {
    0 == $(".alert").length &&
      ($(
        '<div class="alert"><span>Item added to cart. <a href="/cart">View cart and checkout.</a></span><span class="alert__close"></span></div>'
      ).insertAfter(".breadcrumbs nav"),
        $(".header__cart-active.hide").removeClass("hide"));
  }),
  $("body").on("click", ".faqTitle", function () {
    $(this).parent().toggleClass("active"),
      $(this).parent().find(".faqContent").slideToggle();
  }),
  $(document).on("click", ".js-pagination", function () {
    $(this),
      parseInt($(this).attr("data-curent-page"), 10),
      parseInt($(this).attr("data-pages"), 10),
      $(this).attr("data-url"),
      console.log(this.getBoundingClientRect().top + pageYOffset),
      console.log(
        this.getBoundingClientRect().top +
        pageYOffset -
        document.documentElement.clientWidth
      ),
      console.log(pageYOffset),
      pageYOffset >
        this.getBoundingClientRect().top +
        pageYOffset -
        document.documentElement.clientWidth
        ? console.log("true")
        : console.log("false");
  }),
  $(document).on("scroll", function () {
    if ($(".js-pagination").length) {
      let t = $(".js-pagination"),
        e = parseInt(t.attr("data-curent-page"), 10),
        i = parseInt(t.attr("data-pages"), 10),
        o = t.attr("data-url"),
        a = t.attr("data-loading"),
        n = document.querySelector(".products-grid.products-grid-collections"),
        r = n.getBoundingClientRect().top + pageYOffset,
        c = n.offsetHeight;
      pageYOffset > r + c - document.documentElement.clientWidth &&
        e != i &&
        "true" != a &&
        (console.log(a),
          $(".infinity-pagination .loading").show(),
          t.attr("data-loading", "true"),
          setTimeout(function () {
            fetch(`${o}?page=${e + 1}`)
              .then(function (t) {
                return t.text();
              })
              .then(function (i) {
                var o = new DOMParser().parseFromString(i, "text/html");
                document
                  .querySelector(".products-grid.products-grid-collections")
                  .insertAdjacentHTML(
                    "beforeend",
                    o.querySelector(".products-grid.products-grid-collections")
                      .innerHTML
                  ),
                  console.log("success"),
                  t.attr("data-curent-page", e + 1),
                  t.attr("data-loading", "false"),
                  $(".infinity-pagination .loading").hide();
              })
              .catch(function (t) {
                console.error("Something went wrong.", t);
              });
          }, 500));
    }
  }),
  $(document).ready(function () {
    $(".text_block_soon").length && $(".text_block_hover"),
      $(document).scrollTop() > 0 && $("body").addClass("scrolled"),
      $(window).on("scroll", function () {
        console.log($(document).scrollTop()),
          $(document).scrollTop() > 0
            ? $("body").addClass("scrolled")
            : $("body").removeClass("scrolled");
      }),
      $(document).on("submit", ".product-card-form", function () { }),
      $(document).on(
        "click",
        ".js-cart-quantity .js-qty__adjust--plus",
        function () {
          let t = $(this).parent().parent(),
            e = t.data("title"),
            i = parseInt(t.data("product_id")),
            o = parseInt(t.data("variant_id")),
            variantTitle = t.data("variant_title"),
            a = parseFloat(t.data("price")),
            n = t.data("collection_1");

          const productData =
            JSON.parse(localStorage.getItem("productData")) || [];

          const productId = i.toString();
          const productVariantId = o.toString();

          let productInfo = productData.find(
            (item) => item.id.toString() === productId
          );

          if (!productInfo) {
            productInfo = productData.find(
              (item) => item.id.toString() === productVariantId
            );
          }

          const blockName = productInfo ? productInfo.blockName : "Direct";
          const position = productInfo ? productInfo.position : 1;

          const categoryData = {
            "Music Streaming": {
              "Spotify Promotion": "Music Streaming",
              "Apple Music Promotion": "Music Streaming",
              "Tidal Promotion": "Music Streaming",
              "Audiomack Promotion": "Music Streaming",
              "Deezer Promotion": "Music Streaming",
              "Playlist Placement": "Music Streaming",
              "Hip-Hop Promotion": "Music Streaming",
            },
            "Social Promotion": {
              "Instagram Promotion": "Social Promotion",
              "TikTok Promotion": "Social Promotion",
              "Facebook Promotion": "Social Promotion",
              "Resident Advisor Promotion": "Social Promotion",
              "Music Blogs Submission": "Social Promotion",
            },
            "Music Promotion": {
              "Youtube Promotion": "Music Promotion",
              "SoundCloud Promotion": "Music Promotion",
              "iTunes Top 100 Promotion": "Music Promotion",
              "Beatport Promotion": "Music Promotion",
              "Music Promotion Packages": "Music Promotion",
              "Shazam Promotion": "Music Promotion",
              "Bandcamp Promotion": "Music Promotion",
              "Mixcloud Promotion": "Music Promotion",
              "Music Promotion Guides": "Music Promotion",
            },
          };

          let itemCategory2 = "";
          let itemListName = blockName;

          for (const [parentCategory, subCategories] of Object.entries(
            categoryData
          )) {
            if (subCategories[n]) {
              itemCategory2 = parentCategory;
            }
            if (subCategories[blockName]) {
              itemListName = `${parentCategory} || ${blockName}`;
            }
          }

          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
              items: [
                {
                  item_name: e.trim(),
                  item_id: "shopify_US_" + i + "_" + o,
                  price: a,
                  item_category: itemCategory2,
                  item_category2: n,
                  item_variant: variantTitle,
                  item_list_name: itemListName,
                  index: position,
                  quantity: 1,
                },
              ],
            },
          });

          console.log("Data Layer updated:", {
            event: "add_to_cart",
            item_category: n,
            item_category2: itemCategory2,
            item_list_name: itemListName,
            index: position,
          });
        }
      );
    let t = 0;
    $(document).on("focus", ".js-cart-quantity .js-qty__input", function () {
      t = parseInt($(this).val());
    }),
      $(document).on("blur", ".js-cart-quantity .js-qty__input", function () {
        let e = parseInt($(this).val()) - t;
        if (e > 0) {
          let i = $(this).parent().parent(),
            o = i.data("title"),
            a = parseInt(i.data("product_id")),
            n = parseInt(i.data("variant_id")),
            variantTitle = i.data("variant_title"),
            r = parseFloat(i.data("price")),
            c = i.data("collection_1");

          const productData =
            JSON.parse(localStorage.getItem("productData")) || [];
          const productId = a.toString();
          const productVariantId = n.toString();

          let productInfo = productData.find(
            (item) => item.id.toString() === productId
          );

          if (!productInfo) {
            productInfo = productData.find(
              (item) => item.id.toString() === productVariantId
            );
          }

          const blockName = productInfo ? productInfo.blockName : "Direct";
          const position = productInfo ? productInfo.position : 1;

          const categoryData = {
            "Music Streaming": {
              "Spotify Promotion": "Music Streaming",
              "Apple Music Promotion": "Music Streaming",
              "Tidal Promotion": "Music Streaming",
              "Audiomack Promotion": "Music Streaming",
              "Deezer Promotion": "Music Streaming",
              "Playlist Placement": "Music Streaming",
              "Hip-Hop Promotion": "Music Streaming",
            },
            "Social Promotion": {
              "Instagram Promotion": "Social Promotion",
              "TikTok Promotion": "Social Promotion",
              "Facebook Promotion": "Social Promotion",
              "Resident Advisor Promotion": "Social Promotion",
              "Music Blogs Submission": "Social Promotion",
            },
            "Music Promotion": {
              "Youtube Promotion": "Music Promotion",
              "SoundCloud Promotion": "Music Promotion",
              "iTunes Top 100 Promotion": "Music Promotion",
              "Beatport Promotion": "Music Promotion",
              "Music Promotion Packages": "Music Promotion",
              "Shazam Promotion": "Music Promotion",
              "Bandcamp Promotion": "Music Promotion",
              "Mixcloud Promotion": "Music Promotion",
              "Music Promotion Guides": "Music Promotion",
            },
          };

          let itemCategory2 = "";
          let itemListName = blockName;

          for (const [parentCategory, subCategories] of Object.entries(
            categoryData
          )) {
            if (subCategories[c]) {
              itemCategory2 = parentCategory;
            }
            if (subCategories[blockName]) {
              itemListName = `${parentCategory} || ${blockName}`;
            }
          }

          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
              items: [
                {
                  item_name: o.trim(),
                  item_id: "shopify_US_" + a + "_" + n,
                  price: r,
                  item_category: itemCategory2,
                  item_category2: c,
                  item_list_name: itemListName,
                  item_variant: variantTitle,
                  index: position,
                  quantity: e,
                },
              ],
            },
          });

          console.log("Data Layer updated:", {
            event: "add_to_cart",
            item_category: c,
            item_category2: itemCategory2,
            item_list_name: itemListName,
            index: position,
          });
        }
      }),
      $(document).ready(function () {
        $("#submit-btn").click(function () {
          var t = $("#email-input").val();
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(t)
            ? (localStorage.setItem("userEmail", t), alert("Success"))
            : alert("Incorrect email");
        });
      }),
      $(document).on("keyup", ".js-cart-quantity .js-qty__input", function (e) {
        if (13 == e.keyCode) {
          let i = parseInt($(this).val()) - t;
          if (i > 0) {
            let o = $(this).parent().parent(),
              a = o.data("title"),
              n = parseInt(o.data("product_id")),
              r = parseInt(o.data("variant_id")),
              variantTitle = o.data("variant_title"),
              c = parseFloat(o.data("price")),
              s = o.data("collection_1");

            const productData =
              JSON.parse(localStorage.getItem("productData")) || [];
            const productId = n.toString();
            const productVariantId = r.toString();

            let productInfo = productData.find(
              (item) => item.id.toString() === productId
            );

            if (!productInfo) {
              productInfo = productData.find(
                (item) => item.id.toString() === productVariantId
              );
            }

            const blockName = productInfo ? productInfo.blockName : "Direct";
            const position = productInfo ? productInfo.position : 1;

            const categoryData = {
              "Music Streaming": {
                "Spotify Promotion": "Music Streaming",
                "Apple Music Promotion": "Music Streaming",
                "Tidal Promotion": "Music Streaming",
                "Audiomack Promotion": "Music Streaming",
                "Deezer Promotion": "Music Streaming",
                "Playlist Placement": "Music Streaming",
                "Hip-Hop Promotion": "Music Streaming",
              },
              "Social Promotion": {
                "Instagram Promotion": "Social Promotion",
                "TikTok Promotion": "Social Promotion",
                "Facebook Promotion": "Social Promotion",
                "Resident Advisor Promotion": "Social Promotion",
                "Music Blogs Submission": "Social Promotion",
              },
              "Music Promotion": {
                "Youtube Promotion": "Music Promotion",
                "SoundCloud Promotion": "Music Promotion",
                "iTunes Top 100 Promotion": "Music Promotion",
                "Beatport Promotion": "Music Promotion",
                "Music Promotion Packages": "Music Promotion",
                "Shazam Promotion": "Music Promotion",
                "Bandcamp Promotion": "Music Promotion",
                "Mixcloud Promotion": "Music Promotion",
                "Music Promotion Guides": "Music Promotion",
              },
            };

            let itemCategory2 = "";
            let itemListName = blockName;

            for (const [parentCategory, subCategories] of Object.entries(
              categoryData
            )) {
              if (subCategories[s]) {
                itemCategory2 = parentCategory;
              }
              if (subCategories[blockName]) {
                itemListName = `${parentCategory} || ${blockName}`;
              }
            }

            dataLayer.push({ ecommerce: null });
            dataLayer.push({
              event: "add_to_cart",
              ecommerce: {
                items: [
                  {
                    item_name: a.trim(),
                    item_id: "shopify_US_" + n + "_" + r,
                    price: c,
                    item_category: itemCategory2,
                    item_category2: s,
                    item_list_name: itemListName,
                    item_variant: variantTitle,
                    index: position,
                    quantity: i,
                  },
                ],
              },
            });

            console.log("Data Layer updated:", {
              event: "add_to_cart",
              item_category: s,
              item_category2: itemCategory2,
              item_list_name: itemListName,
              index: position,
            });
          }
        }
      });
  }),
  $(document).on(
    "click",
    ".js-toogle-read-more-btn, .read-more-col",
    function () {
      $(".read-more-content_block").length
        ? $([document.documentElement, document.body]).animate(
          { scrollTop: $(".read-more-content_block").offset().top - 70 },
          1
        )
        : $([document.documentElement, document.body]).animate(
          { scrollTop: $(".collection-footer-title").offset().top - 70 },
          1
        ),
        $(this).hasClass("active")
          ? ($(".readmore-content-rte").slideUp(0),
            $(this).removeClass("active"),
            ($(this)[0].innerHTML = "Read more"))
          : ($(".readmore-content-rte").slideDown(0),
            $(this).addClass("active"),
            ($(this)[0].innerHTML = "Read less"));
    }
  ),
  $(document).on("submit", "#create_customer", function () {
    setCookie("register", "1", { secure: !0, "max-age": 3600 });
  }),
  $(document).on("submit", "#customer_login", function () {
    setCookie("login", "1", { secure: !0, "max-age": 3600 });
  });
$(document).ready(function () {
  let visibleItems = [];
  let itemsPerGroup = 9;
  let processedItems = new Set();

  function pushToDataLayer(items) {
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: "view_item_list",
      ecommerce: {
        items: items.map((item) => ({
          item_name: item.itemName.trim(),
          item_id: item.itemId,
          price: item.price,
          item_category: item.itemCategory2,
          item_category2: item.itemCategory,
          item_variant: item.itemVariant,
          index: item.index,
          item_list_name: item.blockName,
        })),
      },
    });
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const card = $(entry.target);
          const form = card.find(".product-card-form");
          const itemName = form.data("title");
          const productId = parseInt(form.data("product_id"));
          const variantId = parseInt(form.data("variant_id"));
          const variantTitle = form.data("variant_title");
          const price = parseFloat(form.data("price"));
          const collection = form.data("collection_1");
          const parentBlock = card.closest("[data-block-name]");
          const blockName = parentBlock.data("block-name");
          const parentBlock2 = card.closest("[data-index]");
          const dataIndex = parentBlock2.attr("data-index");
          let itemCategory2 = "";
          let itemListName = blockName;

          const categoryData = {
            "Music Streaming": {
              "Spotify Promotion": "Music Streaming",
              "Apple Music Promotion": "Music Streaming",
              "Tidal Promotion": "Music Streaming",
              "Audiomack Promotion": "Music Streaming",
              "Deezer Promotion": "Music Streaming",
              "Playlist Placement": "Music Streaming",
              "Hip-Hop Promotion": "Music Streaming",
            },
            "Social Promotion": {
              "Instagram Promotion": "Social Promotion",
              "TikTok Promotion": "Social Promotion",
              "Facebook Promotion": "Social Promotion",
              "Resident Advisor Promotion": "Social Promotion",
              "Music Blogs Submission": "Social Promotion",
            },
            "Music Promotion": {
              "Youtube Promotion": "Music Promotion",
              "SoundCloud Promotion": "Music Promotion",
              "iTunes Top 100 Promotion": "Music Promotion",
              "Beatport Promotion": "Music Promotion",
              "Music Promotion Packages": "Music Promotion",
              "Shazam Promotion": "Music Promotion",
              "Bandcamp Promotion": "Music Promotion",
              "Mixcloud Promotion": "Music Promotion",
              "Music Promotion Guides": "Music Promotion",
            },
          };

          for (const [parentCategory, subCategories] of Object.entries(
            categoryData
          )) {
            if (subCategories[collection]) {
              itemCategory2 = parentCategory;
            }
            if (subCategories[blockName]) {
              itemListName = `${parentCategory} || ${blockName}`;
            }
          }

          let index;
          if (dataIndex) {
            index = parseInt(dataIndex);
          } else {
            const cardsInContainer = parentBlock.find(".grid__product-card");
            index = cardsInContainer.index(card) + 1;
          }

          const itemId = `shopify_US_${productId}_${variantId}`;
          if (processedItems.has(itemId)) {
            return;
          }

          const item = {
            itemName: itemName,
            itemId: itemId,
            price: price,
            itemCategory: collection,
            itemCategory2: itemCategory2,
            itemVariant: variantTitle,
            index: index,
            blockName: itemListName,
          };

          visibleItems.push(item);
          processedItems.add(itemId);

          if (visibleItems.length >= itemsPerGroup) {
            pushToDataLayer(visibleItems.slice(0, itemsPerGroup));
            visibleItems = visibleItems.slice(itemsPerGroup);
          }
        }
      });
    },
    { threshold: 0.5 }
  );

  function observeNewCards() {
    $(".grid__product-card").each(function () {
      if (!this._observed) {
        observer.observe(this);
        this._observed = true;
      }
    });
  }

  const mutationObserver = new MutationObserver(() => {
    observeNewCards();
  });

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  observeNewCards();

  $(window).on("beforeunload", function () {
    if (visibleItems.length > 0) {
      pushToDataLayer(visibleItems);
    }
  });
});
$(document).ready(function () {
  if ($(window).width() > 768) {
    $(document).on('mouseenter', '.toggle-selector, .variant-selector', function () {
      $(this).addClass('active');
      $(this).closest('.product-card-form').find('.variant-selector').show();
      $(this).closest('.product-card-form').find('.buy-btn').addClass('hover');
    }).on('mouseleave', '.toggle-selector', function (e) {
      var $relatedTarget = $(e.relatedTarget);
      if (!$relatedTarget.closest('.variant-selector').length) {
        $(this).removeClass('active');
        $(this).closest('.product-card-form').find('.variant-selector').hide();
        $(this).closest('.product-card-form').find('.buy-btn').removeClass('hover');
      }
    }).on('mouseleave', '.variant-selector', function (e) {
      $(this).hide();
      $(this).closest('.product-card-form').find('.toggle-selector').removeClass('active');
      $(this).closest('.product-card-form').find('.buy-btn').removeClass('hover');
    });
  }
  if ($(window).width() < 768) {
    $(document).on('click', '.toggle-selector', function () {
      const $form = $(this).closest('.product-card-form');
      const $selector = $form.find('.variant-selector');

      $selector.toggle();
      $form.find('.buy-btn').toggleClass('hover');
      $(this).toggleClass('active');
    });
  }
  $(document).on('click', '.variant-option', function (event) {
    const $option = $(this);
    const $form = $option.closest('.product-card-form');
    const variantId = $option.data('variant-id');
    const variantTitle = $option.data('variant-title');
    const price = $option.data('price');

    $form.data('variant_id', variantId);
    $form.data('variant_title', variantTitle);
    $form.data('price', price);

    $form.find('input[name="id"]').val(variantId);

    $form.find('.buy-btn').click();
  });

  $(this).on('click', '.js-scroll-up', function (e) {
    e.preventDefault();

    $('html, body').animate({ scrollTop: 0 }, 800);
  });
});
